/**
 * @generated SignedSource<<945b5d95bad39e5be0929bfa70497b03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamScheduleAdminArchivedScreenListItem_unarchiveMutation$variables = {
  id: string;
};
export type TeamScheduleAdminArchivedScreenListItem_unarchiveMutation$data = {
  readonly routine: {
    readonly unarchiveRoutine: {
      readonly id: string;
      readonly isArchived: boolean;
    } | null;
  } | null;
};
export type TeamScheduleAdminArchivedScreenListItem_unarchiveMutation = {
  response: TeamScheduleAdminArchivedScreenListItem_unarchiveMutation$data;
  variables: TeamScheduleAdminArchivedScreenListItem_unarchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "unarchiveRoutine",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamScheduleAdminArchivedScreenListItem_unarchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamScheduleAdminArchivedScreenListItem_unarchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c52197a4d9acb7c4bcb5d6abe3a665d5",
    "id": null,
    "metadata": {},
    "name": "TeamScheduleAdminArchivedScreenListItem_unarchiveMutation",
    "operationKind": "mutation",
    "text": "mutation TeamScheduleAdminArchivedScreenListItem_unarchiveMutation(\n  $id: ID!\n) {\n  routine(id: $id) {\n    unarchiveRoutine {\n      id\n      isArchived\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "71dedbf710c40c267274a41a8c50894b";

export default node;
